import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MissingDataService {
  private data: any;

  setData(newData: any): void{
    if(newData !== null){
      this.data = Object.keys(newData).map(key => ({type: key, value: newData[key]}));
    } else {
      this.data = null;
    }
  }

  setDataManually(newData: any): void{
    if(newData !== null){
      this.data = newData;
    } else {
      this.data = null;
    }
  }

  getData(): any{
    return this.data;
  }
}
